import Form from "./Form";
import useJointPolicyholderInformation from "./hooks/useJointPolicyholderInformation";

export const JointPolicyholderInformation: React.FC = () => {
  const { ...props } = useJointPolicyholderInformation();

  return <Form {...props} />;
};
export default JointPolicyholderInformation;
